<template>
    <div class="appointment-list__app">
        <div class="col-wrapper -max-width-limited">
            <div class="module-filter-form">
                <form v-if="layout === 'career'" class="filter-form__form" @submit.prevent="submit()">
                    <div class="form-wrapper -bg-white">
                        <div class="col selectbox">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control" id="searchCategory" v-model="selectedCategory">
                                        <option value="-1">{{ $t('search.categories') }}</option>
                                        <option v-for="(category, key) in categories" :value="category.localizedUid.toString()" :key="key">
                                            {{ category.name }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchCategory"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col selectbox">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control" id="searchDateTimeFrom" v-model="selectedDateTimeInterval">
                                        <option :value="{ from: '', to: '' }">{{ $t('search.times') }}</option>
                                        <option v-for="(dateTimeInterval, key) in dateTimeIntervals" :value="dateTimeInterval" :key="key">
                                            {{
                                                $moment(dateTimeInterval.from, 'X')
                                                        .format('YYYY')
                                            }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchDateTimeFrom"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <form v-else class="filter-form__form" @submit.prevent="submit()">
                    <div class="form-wrapper -bg-white">
                        <div class="col selectbox">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control" id="searchLocation" v-model="selectedLocation">
                                        <option value="-1">{{ $t('search.locations') }}</option>
                                        <option v-for="(location, key) in locations" :value="location.localizedUid.toString()" :key="key">
                                            {{ location.name }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchLocation"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col selectbox">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control" id="searchDateTimeFrom" v-model="selectedDateTimeInterval">
                                        <option :value="{ from: '', to: '' }">{{ $t('search.times') }}</option>
                                        <option v-for="(dateTimeInterval, key) in dateTimeIntervals" :value="dateTimeInterval" :key="key">
                                            {{
                                                $moment(dateTimeInterval.from, 'X')
                                                        .format('YYYY')
                                            }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchDateTimeFrom"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col selectbox">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control" id="searchIndustry" v-model="selectedIndustry">
                                        <option value="-1">{{ $t('search.industries') }}</option>
                                        <option v-for="(industry, key) in industries" :value="industry.localizedUid.toString()" :key="key">
                                            {{ industry.name }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchIndustry"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col selectbox">
                            <div class="form-group selectbox">
                                <div class="input">
                                    <select class="form-control" id="searchCategory" v-model="selectedCategory">
                                        <option value="-1">{{ $t('search.categories') }}</option>
                                        <option v-for="(category, key) in categories" :value="category.localizedUid.toString()" :key="key">
                                            {{ category.name }}
                                        </option>
                                    </select>
                                    <div class="input-background">
                                        <label class="control-label" for="searchCategory"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="filter-form__selected" v-if="initialized && (selectedCategory !== '-1' || selectedLocation !== '-1' || selectedIndustry !== '-1' || selectedDateTimeInterval.from !== '')">
                    <div class="selected__wrapper">
                        <div class="selected__item" v-if="selectedLocation !== '-1'" @click="selectedLocation = '-1'"><span class="icon-times-after">{{ locations.filter(location => location.localizedUid.toString() === selectedLocation)[0].name }}</span></div>
                        <div class="selected__item" v-if="selectedDateTimeInterval.from !== ''" @click="selectedDateTimeInterval = { from: '', to: '' }"><span class="icon-times-after">{{
                                $moment(selectedDateTimeInterval.from, 'X')
                                        .format('YYYY')
                            }}</span></div>
                        <div class="selected__item" v-if="selectedIndustry !== '-1'" @click="selectedIndustry = '-1'"><span class="icon-times-after">{{ industries.filter(industy => industy.localizedUid.toString() === selectedIndustry)[0].name }}</span></div>
                        <div class="selected__item" v-if="selectedCategory !== '-1'" @click="selectedCategory = '-1'"><span class="icon-times-after">{{ categories.filter(category => category.localizedUid.toString() === selectedCategory)[0].name }}</span></div>
                    </div>
                    <div class="selected__reset">
                        <span class="link" @click="reset()"><span>{{ $t('search.reset') }}</span></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited">
            <div class="module-appointments">
                <template v-if="!initialized || !appointmentsLoad">
                    <div class="appointments__appointment appointments__appointment--loading" v-for="n in currentPage * itemsPerPage" :key="n">
                        <div class="appointment">
                            <div class="appointment__wrapper">
                                <div class="appointment__prefix">
                                    <div class="appointment_date">
                                        <span class="preloader-text" style="width: 75px"></span>
                                    </div>
                                    <div class="appointment__language">
                                        <span class="preloader-text" style="width: 50px"></span>
                                    </div>
                                </div>
                                <div class="appointment__info">
                                    <div class="appointment__title">
                                        <span class="preloader-text"></span>
                                    </div>
                                    <div class="appointment__text">
                                        <span class="preloader-text" style="width: 75%"></span>
                                        <span class="preloader-text" style="width: 50%"></span>
                                        <span class="preloader-text"></span>
                                    </div>
                                </div>
                                <div class="appointment__suffix">
                                    <span class="preloader-text" style="width: 40px"></span>
                                    <span class="preloader-text" style="width: 55px"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="appointments__appointment" v-for="appointment in appointments" :key="appointment.localizedUid">
                        <TypoLink v-if="appointment.link" :link="appointment.link" :link-params="appointment.registrationUid ? '?appointmentUid=' + appointment.registrationUid : ''" class="appointment">
                            <Appointment
                                    :appointment="appointment"
                                    :layout="layout"/>
                        </TypoLink>
                        <div v-else class="appointment">
                            <Appointment
                                    :appointment="appointment"
                                    :layout="layout"/>
                        </div>
                    </div>
                    <div v-if="appointments.length === 0">
                        {{ $t('search.no-results') }}
                    </div>
                </template>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited" v-if="numberOfTotalItems">
            <div class="col">
                <div class="content-item module-load-more">
                    <div class="load-more__button" v-if="currentPage < numberOfPages">
                        <div class="btn -btn-alpha" @click="loadMore">
                            <span>{{ $t('loadMore.btn') }}</span>
                        </div>
                    </div>
                    <div class="load-more__progress" v-if="initialized">
                        <div class="progress__info">
                            <span class="meta" v-html="$t('loadMore.info', { current: appointments.length, total: numberOfTotalItems })"></span>
                        </div>
                        <div class="progress__bar"><span :style="{ width: (appointments.length / numberOfTotalItems * 100) + '%' }"></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Appointment from '@/components/Appointment'
import TypoLink from '@/components/TypoLink'

export default {
    data ()
    {
        return {
            isFetchingData: false,
            layout: window.app.appointment_list.layout
        }
    },
    computed: {
        selectedCategory: {
            get ()
            {
                return this.$store.state.categories.selected
            },
            set (payload)
            {
                this.$store.commit('categories/setSelected', payload)
                if (!this.isFetchingData) this.submit()
            }
        },
        selectedLocation: {
            get ()
            {
                return this.$store.state.locations.selected
            },
            set (payload)
            {
                this.$store.commit('locations/setSelected', payload)
                if (!this.isFetchingData) this.submit()
            }
        },
        selectedIndustry: {
            get ()
            {
                return this.$store.state.industries.selected
            },
            set (payload)
            {
                this.$store.commit('industries/setSelected', payload)
                if (!this.isFetchingData) this.submit()
            }
        },
        selectedDateTimeInterval: {
            get ()
            {
                return this.$store.state.dateTimeIntervals.selected
            },
            set (payload)
            {
                this.$store.commit('dateTimeIntervals/setSelected', payload)
                if (!this.isFetchingData) this.submit()
            }
        },
        ...mapState({
            initialized: state => state.initialized,
            categories: state => state.categories.items,
            locations: state => state.locations.items,
            industries: state => state.industries.items,
            dateTimeIntervals: state => state.dateTimeIntervals.items,
            appointments: state => state.appointments.items,
            appointmentsLoad: state => state.appointments.loaded,
            currentPage: state => state.appointments.currentPage,
            itemsPerPage: state => state.appointments.itemsPerPage,
            numberOfPages: state => state.appointments.numberOfPages,
            numberOfTotalItems: state => state.appointments.numberOfTotalItems
        })
    },
    watch: {
        '$route': function ()
        {
            this.fetchData()
            this.filter()
        }
    },
    components: {
        Appointment,
        TypoLink
    },
    methods: {
        fetchData: function ()
        {
            if (this.$route.name === 'FilterByRouter')
            {
                this.isFetchingData = true
                this.selectedCategory = this.$route.params.category
                this.selectedIndustry = this.$route.params.industry
                this.selectedLocation = this.$route.params.location
                this.selectedDateTimeInterval =
                    this.$route.params.dateTime !== '-1'
                        ? {
                            from: this.$moment(this.$route.params.dateTime, 'YYYY')
                                .startOf('year')
                                .format('X'),
                            to: this.$moment(this.$route.params.dateTime, 'YYYY')
                                .endOf('year')
                                .format('X')
                        }
                        : {
                            from: '',
                            to: ''
                        }
                this.isFetchingData = false
            }
        },
        submit: function ()
        {
            this.$router.push({
                name: 'FilterByRouter',
                params: {
                    location: this.selectedLocation,
                    dateTime: this.selectedDateTimeInterval.from !== '' ? this.$moment(this.selectedDateTimeInterval.from, 'X')
                        .format('YYYY') : '-1',
                    industry: this.selectedIndustry,
                    category: this.selectedCategory
                }
            })
        },
        reset: function ()
        {
            this.isFetchingData = true
            this.selectedLocation = '-1'
            this.selectedDateTimeInterval = {
                from: '',
                to: ''
            }
            this.selectedIndustry = '-1'
            this.selectedCategory = '-1'
            this.isFetchingData = false
            this.submit()
        },
        ...mapActions([
            'init',
            'filter',
            'loadMore'
        ])
    },
    created ()
    {
        this.fetchData()
        this.init()
    }
}
</script>
